import React, { FC } from 'react';
import Button from '@material-ui/core/Button';
import {
    makeStyles,
    createStyles,
    Theme
} from '@material-ui/core/styles';
import GlobalStyles from '../styles/GlobalStyles';

//Styles

interface Props {
    value:string;
    type?: any;
    color: any;
    variant?:any;
    disabled?: boolean;
    className?: string;
    style?: React.CSSProperties;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, data?: any) => void;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void | any;
}

const ButtonComponent: FC<Props> = p => {

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            submit: {
                margin: theme.spacing(3, 1, 2),
                width:"192px",
                background:GlobalStyles.primaryColor,
                '&:hover': {
                    backgroundColor: GlobalStyles.secondaryColor,
                },
                [theme.breakpoints.down('xs')]:{
                    width:"100%",
                    fontSize: "12px"
                }
            },
            outlined: {
                margin: theme.spacing(3, 1, 2),
                width:"192px",
                [theme.breakpoints.down('xs')]:{
                    width:"100%",
                }
            },
            contained: {
                margin: theme.spacing(3, 1, 2),
                width:"192px",
                [theme.breakpoints.down('xs')]:{
                    width:"90%",
                }
            }
        }));

    const classes = useStyles();

    switch (p.variant) {
        case "outlined":
            return (
                <>
                    <Button
                        disabled={p.disabled}
                        type={p.type}
                        variant={p.variant}
                        color={p.color}
                        className={`${classes.outlined} ${p.className}`}
                        style={p.style}
                        size="large"
                        onClick={p.onClick}
                    >
                        {p.value}
                    </Button>
                </>
            );
    
        default:
            return (
                <>
                    <Button
                        disabled={p.disabled}
                        type={p.type}
                        variant={p.variant}
                        color={p.color}
                        className={`${classes.submit} ${p.className}`}
                        style={p.style}
                        size="large"
                        onClick={p.onClick}
                    >
                        {p.value}
                    </Button>
                </>
            );
    }
}
export default ButtonComponent;
